import { ImageViewer } from './viewer';

export class Gallery {
  constructor(container = document) {
    this.init(container);
  }

  init(container) {
    const $root = $(container);

    $root.find('.gallery').each((_, el) => {
      const $gallery = $(el);

      if ($gallery.data('viewer')) return;
      if (!$gallery.find('img').length) return;

      this.initViewer($gallery);
    });

    $root.find('.comment-input[data-attribute-name="body"]').each((_, el) => {
      const $comment = $(el);

      if ($comment.find('.gallery').length) return;
      if (!$comment.find('figure img').length) return;

      this.initViewer($comment);
    });
  }

  initViewer($container) {
    if ($container.data('viewer')) return;

    const protect = $container.data('protect') === true;
    const viewer = new ImageViewer($container[0], { protect });
    $container.data('viewer', viewer.viewer);

    if (protect) {
      $container.on('contextmenu', (e) => e.preventDefault());
    }

    $container.on('click', 'img, svg', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $clicked = $(this);

      const $img = $clicked.is('svg')
        ? $clicked.siblings('img.viewer-hidden-thumb')
        : $clicked;

      if (!$img.length) return;

      const index = $container.find('img').index($img);
      if (index < 0) return;

      viewer.view(index);
    });
  }
}

$(function () {
  new Gallery();
});

window.initGallery = (container) => new Gallery(container);
